jQuery(document).ready(function ($) {

	$(document).on('click', '.js-search-filter-query-posts .pagination a', function() {
		setTimeout(function() {
			const $results = $('.js-search-filter-query-posts');

			if (!$results.length) {
				return;
			}

			const offset = 110;

			$('html, body').animate({
				scrollTop: $results.offset().top - offset
			}, 500);

		}, 50);

	});

	$('.js-tenant-portal-popup a').on('click', function(e) {
		e.preventDefault();

		Fancybox.show([
			{
				src: '#js-tenant-portal-popup',
				type: 'inline'
			}
		], {
			autoFocus: false
		});
	});

	$(document).on('click', '.js-popup-close', function() {
		Fancybox.close();
	});


});
